<div style="height: 600px;"
      leaflet
      [leafletOptions]="options"
      [leafletLayers]="layers"
      (leafletMapReady)=onMapReady($event)>
</div>
